<template>
    <div class="wrap fixed">
        <div class="menu">
            <div class="title">
                <img v-if="modelName=='产品中心'" src="../assets/project_title.png"/>
                <img v-else-if="modelName=='解决方案'" src="../assets/solve_title.png"/>
                <img v-else src="../assets/about_title.png"/>
                 {{modelName}}
            </div>
            <a-menu
                :defaultSelectedKeys="selectedKeys"
                v-if="selectedKeys"
                :selectedKeys="selectedKeys"
                :defaultOpenKeys="defaultOpenKeys"
                :openKeys="openKeys"
                @openChange="$emit('openChange',$event)"
                mode="inline"
                v-on:click="handleClick"
                :class="{'menu_list':true,'isCenter':isCenter}"
                :popupClassName="'color:red'"
            >
                <template v-for="value in title">
                    <a-menu-item v-if="value.menuList==''" :key='value.id'><span>{{value.title}}</span></a-menu-item>
                    <a-sub-menu v-else :key="value.id">
                        <span slot="title" :title="value.title"><span>{{value.title}}</span></span>
                        <a-menu-item v-for="second in value.menuList" :title="second.title" :key="value.id+'-'+second.id">{{second.title}}</a-menu-item>  
                    </a-sub-menu>
                </template>
        </a-menu>
        </div>
        <div class="content">
            <div class="content_title">
                <h3>{{cateName}}</h3>
                <p>
                    <a-breadcrumb  separator=">">
                        <a-breadcrumb-item><span @click="returnHome()" class="returnHome"><a-icon type="home" />当前所在页面：<span>首页</span></span></a-breadcrumb-item>
                        <a-breadcrumb-item><span>{{location[0]}}</span></a-breadcrumb-item>
                        <a-breadcrumb-item style="color:#5c8aff">{{cateName}}</a-breadcrumb-item>
                    </a-breadcrumb>
                </p>
            </div>
            <div class="content_body">
                <slot></slot>
            </div>
            
        </div>
    </div>
</template>
<script>
import {Icon} from "ant-design-vue"
export default {
    name:"wrap",
    props:{openKeys:Array,cateName:String,title:Array,location:Array,modelName:String,isCenter:{type:Boolean,default:false},selectedKeys:Array,defaultOpenKeys:Array},
    components:{
        aIcon:Icon
    },
    methods:{
        handleClick (e) {
            this.$emit('change-page', e.keyPath)
            
        },
        returnHome(){
            this.$router.push({path:'/'})
        }
    }
}
</script>
<style>
.ant-menu-inline .ant-menu-submenu-title{
    font-size:16px;
}
.wrap .isCenter li{
    padding-right:24px;
    text-align: center;
    line-height:52px;
    height:52px;
    border-bottom:1px solid #e7e7e6;
}
.ant-menu-inline > .ant-menu-item,
.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-sub.ant-menu-inline > .ant-menu-item{
    line-height:52px;
    height:52px;
    border-bottom:1px solid #e7e7e6;
    margin:0;
}
.ant-menu-submenu-selected .ant-menu-submenu-title{
    background:#2b83ff;
    color:#fff
}
.about .body .wrap .menu .ant-menu-item-selected{background:#2b83ff;
    color:#fff}
</style>
<style lang="stylus" scoped>
    .wrap
        padding:45px 0;
        display:flex;
        justify-content:space-between;
        background:#f3f3f2;
        .menu
            width:298px;
            .title
                background:#3f3b3a;
                color:#fff;
                line-height:72px;
                font-size:24px;
                img 
                    margin:0 20px;
            
            .ant-menu-item-selected
                background:#fff;
                color:#2b83ff;
                margin:0;
                &:after
                    display:none;
                
            .ant-menu-submenu-title
                font-size:16px;
            .ant-menu-item
                font-size:16px;
                margin:0;
        .content
            width:882px;
            background:#fff

            .content_title
                line-height:72px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                border-bottom:2px solid #e7e7e6
                padding:0 30px;
                h3
                    margin:0;
                    font-size:22px;
                p
                    margin:0;
            .returnHome
                cursor:pointer;
                span
                    &:hover
                        color:rgb(92, 138, 255);

</style>